import { useTranslation } from 'react-i18next'

import type { SelectOption } from '@/components/Select/Select'
import { AsyncSelect } from '@/components/common/AsyncSelect'
import { domainsQueryOptions } from '@/queries/domainsQueryOptions'
import type { FormFieldType } from '@/types/form-field-type'

const DomainSelect = (props: FormFieldType<SelectOption<string>>) => {
  const { t } = useTranslation('coursesManagement')

  return (
    <AsyncSelect
      {...props}
      placeholder={t('placeholder.select-domain')}
      queryOptions={domainsQueryOptions}
    />
  )
}

export default DomainSelect
